var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHairCurler(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.92483 10.5413L10.3039 9.64949C10.7243 9.37763 11.0742 9.01365 11.3261 8.58636L14.1879 3.73136C14.4866 3.22467 14.3093 2.57676 13.792 2.28422C12.7574 1.69913 11.4344 2.04635 10.837 3.05974L2.73203 16.8098C1.90359 17.8032 1.74166 19.2337 2.43526 20.4104C3.33128 21.9305 5.31576 22.4513 6.86772 21.5737C6.88248 21.5653 6.89715 21.5569 6.91173 21.5483L20.918 13.6278C21.9527 13.0427 22.3072 11.7469 21.7098 10.7335C21.4112 10.2268 20.7497 10.0532 20.2323 10.3458L15.2756 13.1488C14.8393 13.3955 14.4677 13.7383 14.1902 14.15L13.2796 15.5008L8.43621 18.2397C8.3706 17.8943 8.24494 17.5538 8.05539 17.2322C7.56972 16.4083 6.76427 15.8779 5.88124 15.7047L8.92483 10.5413ZM5.78612 19.7386C5.2688 20.0312 4.60731 19.8576 4.30864 19.3509C4.00996 18.8442 4.18721 18.1963 4.70453 17.9037C5.22185 17.6112 5.88334 17.7848 6.18201 18.2915C6.48069 18.7982 6.30344 19.4461 5.78612 19.7386Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHairCurler);
export default __webpack_public_path__ + "static/media/hair-curler.43b5d1319f41fa64b72547d0e79be9e8.svg";
export { ForwardRef as ReactComponent };